import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {Organization} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";


export const useOrganizationsTableColumns = () => {

    const columns: DataTableColumn<Organization>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Organization) => <NavLink to={`/organizations/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'adminAccountId',
            title: I18n.get('Admin Account'),
            width: '1fr',
            render: (item: Organization) => item.adminAccountId,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Organization) => formatTimestamp(item.created as string),
        },
    ];

    return {
        columns,
    };
};
